import BearCanyonDiagram from '@src/sld/bear_canyon/BearCanyonDiagram';
import BeaumontDiagram from '@src/sld/beaumont/Beaumont_Diagram';
import CanyonCountryDiagram from '@src/sld/canyon_country/CanyonCountry_Diagram';
import SageBrushB40Diagram from '@src/sld/sagebrush/sagebrush_b40/SageBrushB40Diagram';
import SageBrushB59Diagram from '@src/sld/sagebrush/sagebrush_b59/SageBrushB59Diagram';
import SuperstitionDiagram from '@src/sld/superstition/SuperstitionDiagram';
import WestFordFlatDiagram from '@src/sld/west_ford_flat/WestFordFlatDiagram';
import { SiteMeta } from '@src/types/SiteMeta';
import storeConnector from '@store/storeConnector';
import { ReactElement } from 'react';
import BrazosBendDiagram from './brazos_bend/BrazosBend_Diagram';
import Evelyn_Diagram from './evelyn/Evelyn_Diagram';
import Hanford_1_Diagram from './hanford/hanford_1/Hanford_1_Diagram';
import Hanford_2_Diagram from './hanford/hanford_2/Hanford_2_Diagram';
import HatchRoadSolarDiagram from './hatchroadsolar/Diagram/Diagram';
import Henrietta_Diagram from './henrietta/Henrietta_Diagram';
import MalagaDiagram from './malaga/Malaga_Diagram';
import Scatterwash_1_Diagram from './scatterwash/Scatterwash_1_Diagram';
import Scatterwash_2_Diagram from './scatterwash/Scatterwash_2_Diagram';

const getSLD = (sitename: string) => {
  let diagram: ReactElement = <div />;

  switch (sitename.toLowerCase()) {
    case 'henrietta':
      diagram = <Henrietta_Diagram />;
      break;
    case 'malaga':
      diagram = <MalagaDiagram />;
      break;
    case 'superstition':
      diagram = <SuperstitionDiagram />;
      break;
    case 'scatterwash 1':
      diagram = <Scatterwash_1_Diagram />;
      break;
    case 'scatterwash 2':
      diagram = <Scatterwash_2_Diagram />;
      break;
    case 'hatchroadsolar':
      diagram = <HatchRoadSolarDiagram />;
      break;
    case 'bear canyon':
      diagram = <BearCanyonDiagram />;
      break;
    case 'west ford flat':
      diagram = <WestFordFlatDiagram />;
      break;
    case 'sagebrush b59':
      diagram = <SageBrushB59Diagram />;
      break;
    case 'sagebrush b40':
      diagram = <SageBrushB40Diagram />;
      break;
    case 'brazos bend':
      diagram = <BrazosBendDiagram />;
      break;
    case 'beaumont':
      diagram = <BeaumontDiagram />;
      break;
    case 'canyon country':
      diagram = <CanyonCountryDiagram />;
      break;
    case 'evelyn':
      diagram = <Evelyn_Diagram />;
      break;
    case 'hanford 1':
      diagram = <Hanford_1_Diagram />;
      break;
    case 'hanford 2':
      diagram = <Hanford_2_Diagram />;
      break;
    default:
      break;
  }

  return diagram;
};

function Diagram({ siteMeta }: { siteMeta: SiteMeta }): ReactElement {
  return getSLD(siteMeta.SiteName);
}

export default storeConnector(Diagram, {
  config: ['siteMeta'],
});
